@charset "UTF-8";

/* src/app/private/components/packages/assign-addon/assign-addon.component.scss */
.order-summary-card {
  background: #f5f7ff;
  border: 1px solid #d6ddff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: 0.2s ease-in-out;
}
.order-summary-card:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}
.order-summary-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 14px;
  color: #3f51b5;
}
.order-addon-name {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 4px;
}
.order-addon-price {
  font-size: 13px;
  color: #555;
}
p-divider {
  margin: 12px 0 !important;
}
.order-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.order-total-label {
  font-weight: 600;
  font-size: 15px;
}
.order-total-value {
  font-size: 22px;
  font-weight: 700;
  color: #3f51b5;
}
.feature-section-title {
  font-weight: 600;
  margin-bottom: 6px;
  color: #444;
}
.feature-list {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}
.feature-list li {
  font-size: 13px;
  color: #444;
  padding: 4px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}
.feature-list li::before {
  content: "\2022";
  color: #3f51b5;
  font-weight: 700;
}
/*# sourceMappingURL=assign-addon.component.css.map */
